import { render, staticRenderFns } from "./Stockpurchase.vue?vue&type=template&id=f8b88d16&scoped=true&"
import script from "./Stockpurchase.vue?vue&type=script&lang=js&"
export * from "./Stockpurchase.vue?vue&type=script&lang=js&"
import style0 from "./Stockpurchase.vue?vue&type=style&index=0&id=f8b88d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b88d16",
  null
  
)

export default component.exports